import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const StatsSection = lazy(() => import("@/components/StatsSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const FeaturedProjects = lazy(() => import("@/components/FeaturedProjects"));
const CTASection = lazy(() => import("@/components/CTASection"));

const SectionFallback = () => <div className="min-h-[40vh]" aria-hidden="true" />;

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="AV Design International | Bespoke Interior Design & Architecture Dubai"
        description="Premier architectural and interior design firm specializing in luxury hospitality, residential, and commercial projects across Dubai and Europe. 1000+ projects."
        canonical="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "AV Design International",
            url: "https://avdesignintl.com",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://avdesignintl.com/portfolio?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://avdesignintl.com/#webpage",
            url: "https://avdesignintl.com/",
            name: "AV Design International — Bespoke Interior Design & Architecture Dubai",
            inLanguage: "en",
            speakable: {
              "@type": "SpeakableSpecification",
              cssSelector: ["h1", "h2"],
            },
            isPartOf: { "@id": "https://avdesignintl.com/#website" },
            about: { "@id": "https://avdesignintl.com/#organization" },
          },
        ]}
      />
      <Navbar />
      <main id="main">
        <HeroSection />
        <AboutSection />
        <Suspense fallback={<SectionFallback />}>
          <StatsSection />
          <FeaturedProjects />
          <ServicesSection />
          <CTASection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
